import { render } from "./MdiPinOutline.vue?vue&type=template&id=8cc8d648"
import script from "./MdiPinOutline.vue?vue&type=script&lang=js"
export * from "./MdiPinOutline.vue?vue&type=script&lang=js"
script.render = render

export default script